import React from 'react';
import wb0 from '../img/Detail/Sora-Detail.jpg';
import './Detail.css';
const SoraDetail = () => {
  return (
    <div className="image-detail-container">
      <img src={wb0} alt="Kuş" />
    </div>
    
  );
};

export default SoraDetail;